import { Outlet, useNavigation } from 'react-router-dom';
import { BottomNavigation } from '@/components/BottomNavigation';
import { UpdatePrompt } from '@/components/UpdatePrompt';
import { CatalogUpdateBanner } from '@/features/sync/CatalogUpdateBanner';

/** Layout base: header por página, conteúdo roteado e navegação inferior fixa. */
export function AppShell(): React.ReactElement {
  const navigation = useNavigation();

  return (
    <div className="min-h-dvh bg-slate-900">
      {/* Atalho para pular direto ao conteúdo — leitores de tela e teclado. */}
      <a
        href="#conteudo"
        className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-50 focus:rounded-lg focus:bg-sky-500 focus:px-4 focus:py-2 focus:text-slate-950"
      >
        Pular para o conteúdo
      </a>

      <main
        id="conteudo"
        // Espaço para a navegação inferior não cobrir o fim da lista.
        className="mx-auto max-w-md px-safe pt-safe"
        style={{ paddingBottom: 'calc(var(--safe-bottom) + 4.5rem)' }}
        aria-busy={navigation.state === 'loading'}
      >
        <CatalogUpdateBanner />
        <Outlet />
      </main>

      <BottomNavigation />
      <UpdatePrompt />
    </div>
  );
}
